// extracted by mini-css-extract-plugin
export default {"searchResultsMenu":"bmn5xwu9paMJ52BVJe2Q","searchResultsEmpty":"QD_ULCHmyWG8JPiNLzv9"};